import { render, staticRenderFns } from "./OpportunitySourceTender.vue?vue&type=template&id=019f1ca4"
import script from "./OpportunitySourceTender.vue?vue&type=script&lang=js"
export * from "./OpportunitySourceTender.vue?vue&type=script&lang=js"
import style0 from "./OpportunitySourceTender.vue?vue&type=style&index=0&id=019f1ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports